<div class="mx-md-5 mx-4 mt-md-5 mt-4">
    <h5>{{ "Are you uploading an existing resume?" | translate }}</h5>
    <p>
        {{ "Just review, edit, and update it with new information" | translate }}
    </p>
</div>

<div class="row m-md-4 m-3">
    <!-- Section 1: Upload New CV -->
    <div class="col-12 col-sm-6 mt-3 mt-sm-auto">
        <div class="card-container" (click)="selectedResumeType = 'upload'"
            [ngClass]="{ selected: selectedResumeType === 'upload' }">
            <img class="mx-auto mb-3" src="../../../../../../assets/img/upload resume.png" />
            <h5>{{ "Upload my Resume" | translate }}</h5>
            <p>
                {{ "Upload your CV and we will read all of data from it" | translate }}
            </p>

            <!-- Upload Section for New CV -->
            <div class="view-cv-section" *ngIf="selectedResumeType === 'upload'">
                <label for="cvFileInput" class="view-cv-btn">
                    <i class="bi bi-upload"></i>
                    {{ (uploadedCV ? "Change CV" : "Upload CV") | translate }}
                </label>
                <input id="cvFileInput" type="file" accept=".pdf,.doc,.docx" (change)="onCVSelected($event)"
                    (click)="$event.stopPropagation()" style="display: none;">

                <!-- Display Uploaded CV Info -->
                <div class="selected-cv-info" *ngIf="uploadedCV">
                    <div class="selected-badge">
                        <i class="bi bi-file-earmark-check-fill"></i>
                        <span>{{ uploadedCV.name }}</span>
                    </div>
                    <button class="remove-selection" (click)="removeCV(); $event.stopPropagation()">
                        <i class="bi bi-x"></i>
                    </button>
                </div>
            </div>

            <input *ngIf="selectedResumeType === 'upload'" type="radio" checked />
        </div>
    </div>

    <!-- Section 2: Use Current CV -->
    <div class="col-12 col-sm-6 mt-3 mt-sm-auto">
        <div class="card-container" (click)="selectedResumeType = 'current'"
            [ngClass]="{ selected: selectedResumeType === 'current' }">
            <img class="mx-auto mb-3 current" src="../../../../../../assets/img/upload cv.png" />
            <h5>{{ "Use Your current CV uploaded" | translate }}</h5>

            <!-- View Current CV Button -->
            <div class="view-cv-section" *ngIf="selectedResumeType === 'current'">
                <button class="view-cv-btn" (click)="openCVSelectionPopup(); $event.stopPropagation()">
                    <i class="bi bi-eye"></i>
                    {{ "View & Select CV" | translate }}
                </button>

                <!-- Display Selected CV -->
                <div class="selected-cv-info" *ngIf="selectedCV">
                    <div class="selected-badge">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>{{ "CV Selected" | translate }}</span>
                    </div>
                    <button class="remove-selection" (click)="removeSelectedCV(); $event.stopPropagation()">
                        <i class="bi bi-x"></i>
                    </button>
                </div>
            </div>

            <input *ngIf="selectedResumeType === 'current'" type="radio" checked />
        </div>
    </div>
</div>

<!-- Navigation Buttons -->
<div class="next-container px-md-4 px-3">
    <button class="border-button m-3" (click)="onPrevious()">
        {{ "Back" | translate }}
    </button>
    <button class="gradient-button m-3" (click)="onNext()" [disabled]="!canProceed()">
        {{ "Next" | translate }}
    </button>
</div>

<!-- CV Selection Popup -->
<app-popup-cv [isvisible]="showCVSelectionPopup" (close)="closeCVSelectionPopup()"
    (cvSelected)="onCVSelectedFromPopup($event)">
</app-popup-cv>